import { render } from "./ContactTemplate.vue?vue&type=template&id=55ea8bce&scoped=true"
import script from "./ContactTemplate.vue?vue&type=script&lang=js"
export * from "./ContactTemplate.vue?vue&type=script&lang=js"

import "./ContactTemplate.vue?vue&type=style&index=0&id=55ea8bce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ea8bce"]])

export default __exports__